
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vendors/login",
      function () {
        return require("private-next-pages/vendors/login/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vendors/login"])
      });
    }
  